export const notFoundIs = {
  title: '404',
  heading: 'Úps! Þessi síða virðist vanta af matseðlinum okkar.',
  description:
    'Það lítur út fyrir að þú hafir pantað eitthvað sem við þjónum ekki. Komum þér aftur á venjulegan matseðil okkar.',
  buttons: {
    home: 'Til baka á forsíðu',
    menu: 'Skoða matseðilinn okkar',
  },
};
